export default __webpack_public_path__ + "static/media/saelos.504c638f.svg";